import { render, staticRenderFns } from "./Videopage.vue?vue&type=template&id=dd9ea906&"
import script from "./Videopage.vue?vue&type=script&lang=js&"
export * from "./Videopage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports